import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

const logout = (makeCall: MakeCall) => () =>
  makeCall<null>('POST', `${APIV2_URL}/action/logout`);

export default logout;
